

import {
    BRAND_OWNER_CLIENTS
} from "../constant/ActionType";

export default function GetAllBrandOwnerReducer(state = {
    getallbrandownerdata: [],
    statuscode: null,
}, action) {
    switch (action.type) {
        case BRAND_OWNER_CLIENTS:
            return {
                ...state,
                getallbrandownerdata: action?.data,
            };

        default:
    }

    return state;
}